import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

const option = z.object({
  value: z.string(),
  label: z.string(),
});

export const planningGridViewTypeEnum = z.enum([
  'media_plan',
  'activity',
  'flight',
]);

export type PlanningGridViewType = z.infer<typeof planningGridViewTypeEnum>;

export const columnsViewTypeEnum = z.enum(['media_plan', 'flight']);

export type ColumnsViewType = z.infer<typeof columnsViewTypeEnum>;

export const column = z.object({
  id: z.string(),
  label: z.string(),
  decimalPlaces: z.number().nullable(),
  isMandatory: z.boolean(),
  isHidden: z.boolean(),
  type: z.enum([
    'currency',
    'date',
    'integer',
    'percent',
    'free_form_text',
    'select',
    'decimal',
    'reference',
  ]),
  options: z.array(option).nullable(),
  disabledOptions: z.array(option).nullable(),
  primaryFieldsUrns: z
    .array(z.string())
    .nullish()
    .transform((value) => value ?? []),
});

export const columnsSchema = createResponseSchema(column);
